import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLParamElement extends HTMLElement { constructor(tagName: string = 'PARAM', ownerDocument?: any) { super(tagName, ownerDocument); } }
